export default function getComponentDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}



// WEBPACK FOOTER //
// ./src/utils/getComponentDisplayName.js